/**
 * Main constants.js file which shall be used for any constant definitions. Will merge all other constants into this file.
 */

// Enum CORP
const CORP = {
  WIPRO: "Wipro",
  SUNPHARMA: "Sunpharma",
};

export const EARLY_CLAIM_STATUSES = [
  "submitted",
  "resubmitted",
  "pre approved",
  "pre rejected",
  "partially pre approved",
  "recheck",
];

const ENTITY_ID_REGISTRY_BY_CORP = {
  [CORP.WIPRO]: [
    { id: 1006778, tag: "" },
    { id: 11189525, tag: "" },
    { id: 11186752, tag: "" },
    { id: 11317947, tag: "" },
  ],
  [CORP.SUNPHARMA]: [
    { id: 1039375, tag: "" },
    { id: 11310642, tag: "" },
  ],
};

const CUSTOMER_SUPPORT_EMAIL_ID = {
  [CORP.WIPRO]: "wipro.support@medibuddy.in",
  [CORP.SUNPHARMA]: "outpatient@medibuddy.in",
};

const DEFAULT_CUSTOMER_SUPPORT_EMAIL = "outpatient@medibuddy.in";

const getCustomerSupportEmailId = () => {
  let pmEntityId = null;

  try {
    const userDetails = localStorage.getItem("mb_user_details");

    if (userDetails) {
      const parsedDetails = JSON.parse(userDetails);

      if (parsedDetails?.pmentityid && !isNaN(parsedDetails.pmentityid)) {
        pmEntityId = parseInt(parsedDetails.pmentityid, 10);
      }
    }
  } catch (error) {
    console.error("Error parsing mb_user_details from localStorage:", error);
    return DEFAULT_CUSTOMER_SUPPORT_EMAIL;
  }

  const corporate = Object.keys(ENTITY_ID_REGISTRY_BY_CORP).find((corp) =>
    ENTITY_ID_REGISTRY_BY_CORP[corp].some((e) => e.id === pmEntityId)
  );

  return corporate
    ? CUSTOMER_SUPPORT_EMAIL_ID[corporate]
    : DEFAULT_CUSTOMER_SUPPORT_EMAIL;
};

const HOST_URL = "https://www.medibuddy.in";
const FORCE_LOGIN_PARAM = "mbcorporatelogin";

export const TIER = {
  STAGING: "STAGING",
  PRODUCTION: "PRODUCTION"
}

export const RELOGIN_URL = `${HOST_URL}?${FORCE_LOGIN_PARAM}=true`;


export { getCustomerSupportEmailId, ENTITY_ID_REGISTRY_BY_CORP };
